import type { MessageCitation, ToolResults } from "../../types";
import type { MessagingMessage } from "@/model/messaging";
import { RxLink1 } from "react-icons/rx";

export const Citations = ({ message }: { message: MessagingMessage }) => {
  const toolResults: ToolResults | undefined = message.payload.data
    ?.tool_results as ToolResults;
  const citations = toolResults?.citations;
  if (!citations || citations.length === 0) {
    return null;
  }
  return (
    <div className="xsm:max-w-72 mt-2 flex max-w-[270px] flex-col gap-2">
      {citations.map((citation, index) => (
        <Citation key={index} citation={citation} />
      ))}
    </div>
  );
};

export const RetrieveCitations = ({
  message,
}: {
  message: MessagingMessage;
}) => {
  const toolResults: ToolResults | undefined = message.payload.data
    ?.tool_results as ToolResults;
  const citations = toolResults?.retrieve?.flatMap(
    (result) => result.citations
  );
  if (!citations || citations.length === 0) {
    return null;
  }
  return (
    <div className="mt-2 flex flex-col gap-2 border-t border-gray-200 pt-2 text-xs">
      <div className="xsm:max-w-72 flex max-w-[270px] flex-col gap-2">
        {citations.map((citation, index) => (
          <Citation key={index} citation={citation} />
        ))}
      </div>
    </div>
  );
};

const Citation = ({ citation }: { citation: MessageCitation }) => {
  return (
    <a
      href={citation.url}
      target="_blank"
      rel=" noreferrer"
      className="hover:bg-accent hover:text-accent-foreground xsm:max-w-72 inline-flex h-7 max-w-[270px] items-center justify-start gap-2 self-start rounded-full border border-gray-200 bg-zinc-50 p-1 px-2"
    >
      <RxLink1 />
      <p className="inline-block overflow-hidden text-nowrap text-ellipsis">
        {citation.title ?? citation.url}
      </p>
    </a>
  );
};
